import nprogress from './plugins/nprogress'
import router from '@/router'
import { useUserInfoStore } from './stores/modules/user'
import { getItem } from './utils/storage'

// 标记动态路由是否已添加（页面刷新后重置）
let dynamicRoutesAdded = false
// 白名单：不需要登录即可访问的页面（官网所有公开页面）
const whiteList = ['/', '/login', '/xiadanxuzhi', '/zaixianxiadan', '/xinwenzixun', '/fuwuzhichi', '/guanyuwomen']

router.beforeEach(async (to, from, next) => {
  console.log('路由守卫被触发') // 添加调试日志
  // 显示进度条
  nprogress.start()
  // 获取用户信息
  const userStore = useUserInfoStore()
  /**
   *  判断用户是否登录
   *  1.未登录，只允许进入 login 页面，完成登录
   *  2.已登录  不允许进入 login 页面
   */
  // 从缓存中获取用户 token 信息
  const token = getItem('token')
  console.log('token', token)
  // 判断如果没有登录，强制跳转到登录页
  if (token) {
    // token 存在，并且请求登录页面，不允许，跳转到原来的页面，原来不存在就跳转到首页
    if (to.path === '/login') {
      next({ path: from.path ? from.path : '/' })
    } else {
      if (JSON.stringify(userStore.user) == '{}') {
        // 跳转时，用户信息为空，则请求用户信息
        await userStore.getUserInfo()
        dynamicRoutesAdded = true
      } else if (!dynamicRoutesAdded && userStore.user.menus && userStore.user.menus.length > 0) {
        // 页面刷新后 vue-router 实例是新的，需要重新注册动态路由
        await userStore.setAsyncRoutes()
        dynamicRoutesAdded = true
      }
      // 角色权限控制：customer 只能访问 /customer，admin 可以访问所有
      const role = userStore.user?.roleCode
      if (role !== 'admin' && role !== 'superadmin' && to.path.startsWith('/admin')) {
        next({ path: '/customer/home' })
        return
      }
      next()
    }
  } else {
    // token 不存在，白名单内的地址可以进入，否则直接跳转到登录页面
    if (whiteList.indexOf(to.path) > -1) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  }
})

router.afterEach(() => {
  // 关闭进度条
  nprogress.done()
})
